import type { BoggleBadgeFamilyId } from './familyTypes'
import type { BoggleBadgeId } from './types'

export function buildTierBadgeId(
  familyId: BoggleBadgeFamilyId,
  tierIndex: number,
): BoggleBadgeId {
  return `${familyId}${tierIndex}` as BoggleBadgeId
}

export function parseTierBadgeId(badgeId: BoggleBadgeId): {
  familyId: BoggleBadgeFamilyId
  tierIndex: number
} | null {
  const match = /^([a-z]+)(\d+)$/.exec(badgeId)
  if (!match) {
    return null
  }
  const familyId = match[1] as BoggleBadgeFamilyId
  const tierIndex = Number(match[2])
  if (!Number.isFinite(tierIndex) || tierIndex < 1) {
    return null
  }
  return { familyId, tierIndex }
}

export function isTieredBadgeId(badgeId: BoggleBadgeId): boolean {
  return parseTierBadgeId(badgeId) !== null
}
